import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, TEMPLATES_CREATE, TEMPLATES_EDIT} from "../../../routes/frontend.routes";
import {createColumnHelper} from "@tanstack/react-table";
import {IndeterminateCheckbox} from "../../../../app-common/components/input/checkbox.intermediate";
import React from "react";
import {TableComponent} from "../../../../app-common/components/table/table";
import {TEMPLATE_LIST} from "../../../../api/routing/routes/admin.backend.app";
import {Template} from "../../../../api/model/sent";
import {Link} from "react-router-dom";
import moment from "moment";

export const Templates = () => {
  const {t} = useTranslation();
  const columnHelper = createColumnHelper<Template>();

  const columns = [
    columnHelper.accessor('uuid', {
      enableSorting: false,
      header: ({table}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        </div>
      ),
      cell: ({row}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    }),
    columnHelper.accessor('name', {
      header: () => t('Name'),
    }),
    columnHelper.accessor('message', {
      header: () => t('Message'),
    }),
    columnHelper.accessor('isActive', {
      header: () => t('Active?'),
      cell: info => info.getValue() ? t('Yes') : t('No')
    }),
    columnHelper.accessor('updatedAt.datetime', {
      header: () => t('Updated at'),
      cell: info => moment(info.getValue()).format('lll'),
    }),
    columnHelper.accessor('uuid', {
      header: () => t('Actions'),
      cell: info => (
        <Link to={TEMPLATES_EDIT.replace(':id', info.getValue())} className="btn btn-primary">
          {t('Update')}
        </Link>
      ),
    })
  ];

  return (
    <DashboardLayout
      title="Templates"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Templates'), current: true}
      ]}
      buttons={[
        <Link to={TEMPLATES_CREATE} className="float-end btn btn-primary">{t('Create')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('List')}
              </h5>
              <TableComponent columns={columns} url={TEMPLATE_LIST}/>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
